import { render, staticRenderFns } from "./PendingStudents.vue?vue&type=template&id=b6c047a8&"
import script from "./PendingStudents.vue?vue&type=script&lang=js&"
export * from "./PendingStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports